import { Icon } from './Icon';

export const UploadIcon = ({className}: {className?: string}) => {
  return (
    <div className={`flex items-center justify-center size-9 custom-border bg-[#1E1E1E0D] rounded-sm text-black py-2 ${className}`}>
      <Icon name="upload" width={13} height={18} className=" text-black" />
    </div>
  );
};
